function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 84.715,
  y: 46.99,
  width: 50.301,
  height: 2.4418,
  strokeWidth: 0.065883
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 132.13,
  y: 46.965,
  width: 2.9167,
  height: 2.3833,
  fill: "#fff",
  strokeWidth: 0.015673
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 132.88,
  y: 46.964,
  width: 2.158,
  height: 2.4397,
  strokeWidth: 0.01364
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m84.641 46.991v2.517l-2.1797-1.2585 1.0899-0.62923z",
  fill: "none",
  strokeWidth: 0.17326
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m83.175 47.883v0.77914l-0.67476-0.38957 0.33738-0.19479z",
  strokeWidth: 0.053636
});

var _ref7 = /*#__PURE__*/React.createElement("g", {
  strokeWidth: 0.4
}, /*#__PURE__*/React.createElement("rect", {
  x: 97.908,
  y: 39.385,
  width: 20.71,
  height: 0.46227
}), /*#__PURE__*/React.createElement("rect", {
  x: 97.908,
  y: 37.861,
  width: 20.71,
  height: 0.46227
}), /*#__PURE__*/React.createElement("rect", {
  x: 97.908,
  y: 36.429,
  width: 20.71,
  height: 0.46227
}), /*#__PURE__*/React.createElement("rect", {
  x: 97.908,
  y: 40.956,
  width: 20.71,
  height: 0.46227
}), /*#__PURE__*/React.createElement("rect", {
  x: 97.908,
  y: 42.388,
  width: 20.71,
  height: 0.46227
}), /*#__PURE__*/React.createElement("rect", {
  x: 97.908,
  y: 44.05,
  width: 20.71,
  height: 0.46227
}), /*#__PURE__*/React.createElement("rect", {
  x: 97.908,
  y: 45.529,
  width: 20.71,
  height: 0.46227
}), /*#__PURE__*/React.createElement("rect", {
  x: 97.908,
  y: 47.053,
  width: 20.71,
  height: 0.46227
}), /*#__PURE__*/React.createElement("rect", {
  x: 97.908,
  y: 48.716,
  width: 20.71,
  height: 0.46227
}), /*#__PURE__*/React.createElement("rect", {
  x: 97.908,
  y: 50.148,
  width: 20.71,
  height: 0.46227
}), /*#__PURE__*/React.createElement("rect", {
  x: 97.908,
  y: 51.533,
  width: 20.71,
  height: 0.46227
}));

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 97.865,
  y: 53.154,
  width: 10.818,
  height: 0.54761,
  strokeWidth: 0.31465
});

var _ref9 = /*#__PURE__*/React.createElement("g", {
  strokeWidth: 0.30673
}, /*#__PURE__*/React.createElement("rect", {
  x: 108.62,
  y: 34.858,
  width: 10.133,
  height: 0.55554
}), /*#__PURE__*/React.createElement("rect", {
  x: 108.62,
  y: 33.38,
  width: 10.133,
  height: 0.55554
}), /*#__PURE__*/React.createElement("rect", {
  x: 108.62,
  y: 32.087,
  width: 10.133,
  height: 0.55554
}), /*#__PURE__*/React.createElement("rect", {
  x: 108.62,
  y: 30.47,
  width: 10.133,
  height: 0.55554
}), /*#__PURE__*/React.createElement("rect", {
  x: 108.62,
  y: 28.899,
  width: 10.133,
  height: 0.55554
}), /*#__PURE__*/React.createElement("rect", {
  x: 108.62,
  y: 27.56,
  width: 10.133,
  height: 0.55554
}), /*#__PURE__*/React.createElement("rect", {
  x: 108.62,
  y: 25.943,
  width: 10.133,
  height: 0.55554
}));

var _ref10 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(10.381 11.84)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m-3.1208-8.5218h0.37964l0.69357 3.0079h-0.34313l-0.18252-0.79578h-0.73737l-0.17522 0.78118h-0.34313z",
  stroke: "#000",
  strokeWidth: ".26458px"
}), /*#__PURE__*/React.createElement("path", {
  transform: "matrix(2.5005 0 0 8.302 10.505 54.213)",
  d: "m-5.3814-7.487 0.041051 0.070519 0.056587 0.098596-0.081597 2.916e-4 -0.11368-2.916e-4 0.040546-0.070811z",
  fill: "#fff"
}));

var SvgArticle = function SvgArticle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.6039 0 0 1.1355 -4.8953 -.37986)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.19849 0 0 .31133 -13.247 -4.5822)",
    style: {
      mixBlendMode: "normal"
    }
  }, _ref2, _ref3, _ref4, _ref5, _ref6), /*#__PURE__*/React.createElement("rect", {
    x: 5.782,
    y: 1.4776,
    width: 5.5562,
    height: 12.588,
    fill: "#fff",
    strokeWidth: 0.049715,
    style: {
      mixBlendMode: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.7902,
    y: 1.4543,
    width: 5.5627,
    height: 0.81295,
    strokeWidth: 0.012642,
    style: {
      mixBlendMode: "normal"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.19849 0 0 .31133 -12.978 -4.5822)",
    style: {
      mixBlendMode: "normal"
    }
  }, _ref7, _ref8, _ref9)), _ref10));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArticle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/article.b1f4cfa5.svg";
export { ForwardRef as ReactComponent };